import { ConnectionLineType } from 'reactflow';
import { Organization } from 'models/CompanySetup/organization.model';
import React from 'react';
import OrganisationViewNode from 'views/CompanySetup/OrganisationMap/OrganisationMapNodes/OrganisationViewNode';

const position = { x: 0, y: 0 };
const edgeType = ConnectionLineType.SmoothStep;

const viewNode = (
  <OrganisationViewNode
    organisation={{
      ...new Organization(),
      id: 1,
      name: 'Holland Organization',
      organisationYearWise: {
        id: 1,
        parentName: null,
        isParent: true,
        organizationShare: 20,
        year: 2020,
        totalLocations: 13,
        isActive: true,
      },
    }}
  />
);

export const initialNodes = [
  {
    id: '1',
    data: {
      label: viewNode,
      hasSource: true,
      hasTarget: false,
    },
    position,
  },
  {
    id: '3',
    data: { label: viewNode, hasSource: true, hasTarget: true },
    position,
    hidden: true,
  },
  {
    id: '4',
    data: { label: viewNode, hasSource: false, hasTarget: true },
    position,
  },
  {
    id: '2',
    data: { label: viewNode, hasSource: true, hasTarget: true },
    position,
  },
  {
    id: '2a',
    data: { label: viewNode, hasSource: true, hasTarget: true },
    position,
  },
  {
    id: '2b',
    data: { label: viewNode, hasSource: true, hasTarget: true },
    position,
  },
  {
    id: '2c',
    data: { label: viewNode, hasSource: true, hasTarget: true },
    position,
  },
  {
    id: '2d',
    data: { label: viewNode, hasSource: true, hasTarget: true },
    position,
  },
];

export const initialEdges = [
  {
    id: 'e12',
    source: '1',
    target: '2',
    type: edgeType,
    style: {
      stroke: '#D4DBDB',
      strokeWidth: 1,
    },
  },
  {
    id: 'e22a',
    source: '2',
    target: '2a',
    type: edgeType,
    style: {
      stroke: '#D4DBDB',
      strokeWidth: 1,
    },
  },
  {
    id: 'e22b',
    source: '2',
    target: '2b',
    type: edgeType,
    style: {
      stroke: '#D4DBDB',
      strokeWidth: 1,
    },
  },
  {
    id: 'e2b2c',
    source: '2b',
    target: '2c',
    type: edgeType,
    style: {
      stroke: '#D4DBDB',
      strokeWidth: 1,
    },
  },
  {
    id: 'e2c2d',
    source: '2c',
    target: '2d',
    type: edgeType,
    style: {
      stroke: '#D4DBDB',
      strokeWidth: 1,
    },
  },
  {
    id: 'e2d3',
    source: '2d',
    target: '3',
    type: edgeType,
    style: {
      stroke: '#D4DBDB',
      strokeWidth: 1,
    },
  },
  {
    id: 'e34',
    source: '3',
    target: '4',
    type: edgeType,
    style: {
      stroke: '#D4DBDB',
      strokeWidth: 1,
    },
  },
];
